import prototype from '../src/lowcode/prototype';
import prototypeView from '../src/lowcode/prototypeView';
const bundle = {
    prototype,
    prototypeView,
};
export default bundle;
